import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class SquareMediaContentGrid {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * logo grid element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.navContainer = this.sliderElement.querySelector('.js-nav-container');
        this.slides = this.sliderElement.querySelectorAll('.swiper-slide')
        this.init()
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1.1,
            spaceBetween: 20,
            watchOverflow: true,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true
            },
            breakpoints: {
                768: {
                    spaceBetween: 80,
                    slidesPerView: this.slides.length -1
                },
                1024: {
                    spaceBetween: 20,
                    slidesPerView: this.slides.length
                }
            }
        })
    }
}
